/**
 * nt-lightbox.js
 * A single shared lightbox instance for the whole site. Any section can open
 * it by dispatching:
 *   document.dispatchEvent(new CustomEvent('nt:lightbox-open', {
 *     detail: { title: 'Acrylic Front-Lit', images: ['url1', 'url2'], quoteType: 'Acrylic Front-Lit' }
 *   }))
 * Expects the markup from snippets/nt-lightbox-v2.liquid to be present once
 * on the page (rendered from the layout or the section that needs it).
 */
(function () {
  'use strict';

  var backdrop, box, imgEl, headingEl, tagEl, thumbsEl, prevBtn, nextBtn, quoteBtn;
  var images = [];
  var idx = 0;
  var quoteType = '';
  var quoteCategory = '';
  var lastFocused = null;

  function ready() {
    box = document.querySelector('[data-nt-lightbox]');
    if (!box) return;
    backdrop = document.querySelector('[data-nt-lightbox-backdrop]');
    imgEl = box.querySelector('[data-nt-lightbox-img]');
    headingEl = box.querySelector('[data-nt-lightbox-heading]');
    tagEl = box.querySelector('[data-nt-lightbox-tag]');
    thumbsEl = box.querySelector('[data-nt-lightbox-thumbs]');
    prevBtn = box.querySelector('[data-nt-lightbox-prev]');
    nextBtn = box.querySelector('[data-nt-lightbox-next]');
    quoteBtn = box.querySelector('[data-nt-lightbox-quote]');

    document.addEventListener('nt:lightbox-open', function (e) {
      open(e.detail || {});
    });

    if (backdrop) backdrop.addEventListener('click', close);
    box.querySelectorAll('[data-nt-lightbox-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { show(idx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(idx + 1); });
    if (quoteBtn) {
      quoteBtn.addEventListener('click', function () {
        close();
        document.dispatchEvent(new CustomEvent('nt:request-quote-drawer', { detail: { type: quoteType, category: quoteCategory } }));
      });
    }
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  function open(detail) {
    images = detail.images || [];
    quoteType = detail.quoteType || detail.title || '';
    quoteCategory = detail.quoteCategory || '';
    if (!images.length) return;
    lastFocused = document.activeElement;
    if (headingEl) headingEl.textContent = detail.title || '';
    if (tagEl) tagEl.textContent = "Real design we've built";
    renderThumbs();
    show(0);
    box.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    box.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function show(n) {
    idx = ((n % images.length) + images.length) % images.length;
    if (imgEl) imgEl.src = images[idx];
    var hasMulti = images.length > 1;
    if (prevBtn) prevBtn.hidden = !hasMulti;
    if (nextBtn) nextBtn.hidden = !hasMulti;
    if (thumbsEl) {
      thumbsEl.hidden = !hasMulti;
      thumbsEl.querySelectorAll('[data-nt-lightbox-thumb]').forEach(function (t, i) {
        t.classList.toggle('is-active', i === idx);
      });
    }
  }

  function renderThumbs() {
    if (!thumbsEl) return;
    thumbsEl.innerHTML = '';
    images.forEach(function (url, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nt-lightbox-thumb';
      btn.setAttribute('data-nt-lightbox-thumb', '');
      btn.setAttribute('aria-label', 'Photo ' + (i + 1));
      var img = document.createElement('img');
      img.src = url;
      img.alt = '';
      btn.appendChild(img);
      btn.addEventListener('click', function () { show(i); });
      thumbsEl.appendChild(btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
